"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_input_autosize_1 = __importDefault(require("react-input-autosize"));
const keyDownHandlerProxy_1 = __importDefault(require("./utils/keyDownHandlerProxy"));
const usePredefinedKeyDownHandlers_1 = __importDefault(require("./hooks/usePredefinedKeyDownHandlers"));
const constants_1 = require("./constants");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const TokenCreator = (props, ref) => {
    const { placeholder, disableCreateOnBlur, autoFocus, onFocus, onBlur, onKeyDown, separators, specialKeyDown, onInputValueChange, onPreprocess, onBuildTokenValue, onNewTokenValuesAppend, onLastTokenDelete, } = props;
    const inputRef = (0, react_1.useRef)(null);
    const [inputValue, setInputValue] = (0, react_1.useState)(constants_1.DEFAULT_INPUT_INIT_VALUE);
    const splitPattens = (0, react_1.useMemo)(() => new RegExp(separators.join('|')), [separators]);
    const handleInputValueUpdate = (0, react_1.useCallback)((newValue) => {
        setInputValue(newValue);
        onInputValueChange === null || onInputValueChange === void 0 ? void 0 : onInputValueChange(newValue, inputValue);
    }, [onInputValueChange, inputValue, setInputValue]);
    const handleTokensCreate = (0, react_1.useCallback)((inputString = inputValue) => {
        if (inputString.trim().length === 0) {
            return;
        }
        const inputValues = inputString
            .split(splitPattens)
            .filter((value) => value.trim().length > 0);
        const processedValues = onPreprocess(inputValues);
        const appendTokenValues = processedValues.map((value) => {
            return onBuildTokenValue(value);
        });
        onNewTokenValuesAppend(appendTokenValues);
        handleInputValueUpdate(constants_1.DEFAULT_INPUT_INIT_VALUE);
    }, [
        inputValue,
        splitPattens,
        onPreprocess,
        onBuildTokenValue,
        onNewTokenValuesAppend,
        handleInputValueUpdate,
    ]);
    const handleInputValueChange = (0, react_1.useCallback)((e) => {
        const { value: newInputValue } = e.target;
        const isIncludesSeparators = splitPattens.test(newInputValue);
        if (isIncludesSeparators) {
            handleTokensCreate(newInputValue);
            return;
        }
        handleInputValueUpdate(newInputValue);
    }, [splitPattens, handleTokensCreate, handleInputValueUpdate]);
    const { handleBackspaceKeyDown, handleTabKeyDown, handleEnterKeyDown, handleEscapeKeyDown, } = (0, usePredefinedKeyDownHandlers_1.default)({
        specialKeyDownConfig: specialKeyDown,
        inputInitValue: constants_1.DEFAULT_INPUT_INIT_VALUE,
        inputValue,
        onLastTokenDelete,
        handleInputValueUpdate,
        handleTokensCreate,
    });
    const handleKeyDown = (0, react_1.useCallback)((e) => {
        (0, keyDownHandlerProxy_1.default)(e, {
            onBackspace: handleBackspaceKeyDown,
            onTab: handleTabKeyDown,
            onEnter: handleEnterKeyDown,
            onEscape: handleEscapeKeyDown,
        });
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    }, [
        onKeyDown,
        handleBackspaceKeyDown,
        handleTabKeyDown,
        handleEnterKeyDown,
        handleEscapeKeyDown,
    ]);
    const handleBlur = (0, react_1.useCallback)((e) => {
        if (!disableCreateOnBlur) {
            handleTokensCreate(inputValue);
        }
        onBlur(e);
    }, [disableCreateOnBlur, handleTokensCreate, inputValue, onBlur]);
    const handlePaste = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData('text');
        handleTokensCreate(pastedText);
    }, [handleTokensCreate]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        focus: (options) => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.getInput().focus(options); },
        setValue: handleInputValueUpdate,
        getValue: () => inputValue,
        createTokens: handleTokensCreate,
    }), [handleInputValueUpdate, inputValue, handleTokensCreate]);
    return (react_1.default.createElement("div", { className: styles_scss_1.default['autosized-wrapper'] },
        react_1.default.createElement(react_input_autosize_1.default, { ref: inputRef, autoFocus: autoFocus, placeholder: placeholder, value: inputValue, onChange: handleInputValueChange, onKeyDown: handleKeyDown, onPaste: handlePaste, onFocus: onFocus, onBlur: handleBlur })));
};
const WrappedTokenCreator = (0, react_1.forwardRef)(TokenCreator);
exports.default = WrappedTokenCreator;
